<div class="col-lg-2 col-md-3 col-sm-12 col-xs-12 float-left">
    <h6 class="menu-headers" *ngIf="_per.checkForPermission('USER_MANAGEMENT')">{{'manageUsers' | translate}}</h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('EMPLOYEE_ADMIN')">
        <a [routerLink]="['employeesList']" [routerLinkActive]="['lt-black','medium']">{{'users' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('ORG_ADMIN')">
        <a [routerLink]="['organizationList']" [routerLinkActive]="['lt-black','medium']">{{'orgUnit' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('ORG_TYPE_ADMIN')">
        <a [routerLink]="['organizationUnitType']" [routerLinkActive]="['lt-black','medium']">{{'orgUnitType' |
            translate}}
        </a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('DESIGNATION_ADMIN')">
        <a [routerLink]="['designationList']" [routerLinkActive]="['lt-black','medium']">{{'designation' | translate}}
        </a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('MANAGERLEVEL_ADMIN')">
        <a [routerLink]="['mgrLevelList']" [routerLinkActive]="['lt-black','medium']">{{'empType' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('CATEGORY_ADMIN')">
        <a [routerLink]="['empTypeList']" [routerLinkActive]="['lt-black','medium']">{{'jobCat' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('GRADE_ADMIN')">
        <a [routerLink]="['gradeList']" [routerLinkActive]="['lt-black','medium']">{{'jobGrade' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('OPERATION_DETAILS_ADMIN')">
        <a [routerLink]="['manageOperations']" [routerLinkActive]="['lt-black','medium']">{{'manageOperations' |
            translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('ROLE_ADMIN')">
        <a [routerLink]="['rolesAndPermission']" [routerLinkActive]="['lt-black','medium']">{{'rolesAndPermission' |
            translate}}
        </a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('COB_ADMIN')">
        <a [routerLink]="['cob']" [routerLinkActive]="['lt-black','medium']">{{'customerOnBoarding' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('EMP_BULK_EMPLOYEE_RESIGN')">
        <a [routerLink]="['bulkResignUpload']" [routerLinkActive]="['lt-black','medium']">{{'bulkResign' |
            translate}}
        </a>
    </h6>
    <h6 class="cus-menus" *ngIf="_per.checkForPermission('NOTIFICATION_EDITOR')">
        <a [routerLink]="['notifications']" [routerLinkActive]="['lt-black','medium']">{{'notificationEditor' |
            translate}}
        </a>
    </h6>
    <h6 class="menu-headers" *ngIf="_per.checkForPermission('PROGRAM_MANAGEMENT')">{{'progManagement' | translate}}
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('ANNOUNCEMENT_ADMIN')">
        <a [routerLink]="['announcementProgram']" [routerLinkActive]="['lt-black','medium']">
            {{'announce' | translate}}
        </a>
    </h6>
    <h6 class="cus-menus" *ngIf="this._per.checkForPermission('EMAIL_NOTIFICATION')">
        <a [routerLink]="['emailNotification']" [routerLinkActive]="['lt-black','medium']">{{'emailNotification' |
            translate}}
        </a>
    </h6>
    <h6 class="menu-headers" *ngIf="_per.checkForPermission('TOOLS')">{{'TOOLS' | translate }}</h6>
    <h6 class="cus-menus" *ngIf="_per.checkForPermission('TENANT_CONFIG')">
        <a [routerLink]="['tenantPreference']" [routerLinkActive]="['lt-black','medium']">{{'tenantPreference' |
            translate}}
        </a>
    </h6>
    <h6 class="cus-menus" *ngIf="_per.checkForPermission('USER_GROUP')">
        <a [routerLink]="['userGroup']" [routerLinkActive]="['lt-black','medium']">{{'userGroup' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="_per.checkForPermission('PASSWORD_POLICY')">
        <a [routerLink]="['passwordPolicy']" [routerLinkActive]="['lt-black','medium']">{{'passwordPolicy' |
            translate}}
        </a>
    </h6>
    <h6 class="menu-headers" *ngIf="_per.checkForPermission('SUPER_ADMIN')">{{'superAdmin' | translate}}</h6>
    <h6 class="cus-menus" *ngIf="_per.checkForPermission('TENANT_MANAGEMENT')">
        <a [routerLink]="['tenantManagement']" [routerLinkActive]="['lt-black','medium']">{{'tenant' | translate}}</a>
    </h6>
    <h6 class="cus-menus" *ngIf="_per.checkForPermission('MOBILE_APP_MANAGEMENT')">
        <a [routerLink]="['mobileAppManagement']" [routerLinkActive]="['lt-black','medium']">{{'mobileAppManagement' |
            translate}}
        </a>
    </h6>
    <h6 class="cus-menus" *ngIf="_per.checkForPermission('SUPER_ADMIN')">
        <a [routerLink]="['buildDetails']" [routerLinkActive]="['lt-black','medium']">{{'buildDetails' |
            translate}}
        </a>
    </h6>
</div>
<div class="col-lg-10 col-md-9 col-sm-12 col-xs-12 float-left b-l">
    <router-outlet></router-outlet>
    <div class="loader-div" *ngIf="loaderEnable">
        <div class="loader-gif"></div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/menu/menu.html